/**
 * Define all global constants for the package
 * */

export const WIDGET_LEARNING_CERTIFICATE_TYPE = 'learning-certificate'; // Name of the widget as saved in the layout within widgetType.

export const DATA_SCOPE = 'learning-certificate';
